






















import VuLinkTagAbstract from './VuLinkTagAbstract.vue';

export default {
    name: 'VuLinkTag',
    extends: VuLinkTagAbstract
};
